import React, {useState, useEffect} from "react";
import {useParams, Link} from "react-router-dom";
import axios from "axios";
import LoginModal from "../shared/LoginModal"
import Successwithfeedbackmodal from "../shared/Successwithfeedbackmodal";
import NewLoginModal from "../shared/NewLoginModal";
import FailureModal from "../shared/FailureModal";
import ProfileModal from "../shared/ProfileModal";
import DOMPurify from 'dompurify';
import sample_company from '../../Assets/icons/sample_company.jpg';
import Breadcrumb from "../Breadcrumb";

const JobDetails = () => {

  const {jobId} = useParams();
  const [jobDetails, setJobDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userid = localStorage.getItem("userid");
  const userType = localStorage.getItem("userType");
  const [applied, setApplied] = useState(false);
  const [saved, setSaved] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showNewLoginModal, setShowNewLoginModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({message: "", redirectPath: "/login"});

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  // Function to sanitize HTML but keep safe tags
  const sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li'],
      ALLOWED_ATTR: [], // No attributes allowed
    });
  };

  // Choose which content should allow HTML and which shouldn't
  const renderContent = (content, allowHtml = false) => {
    if (!content) return null;

    if (allowHtml) {
      const sanitized = sanitizeHtml(content);
      return <div dangerouslySetInnerHTML={{__html: sanitized}}/>;
    }

    return <p>{stripHtml(content)}</p>;
  };

  const addApplication = async (jobId) => {
    try {
      if (!userid) {
        setModalConfig({
          message: "Please log in to apply for this job",
          redirectPath: "/login"
        });
        setApplied(true);
        setShowNewLoginModal(true);
        return;
      }
      const response = await axios.post(`${process.env.REACT_APP_API_URL}job_application/createapplication/${jobId}/${userid}`);
      setApplied(true);
      setShowSuccessModal(true);

    } catch (error) {
      console.log('Application error:', error);
      setShowFailureModal(true);
    }
  };

  const AddToWishlist = async (job_id) => {
    const updateWishlist = {userid: userid, job_id: job_id, isactive: 1};
    try {
      if (!userid) {
        setModalConfig({
          message: "Please Login to save this job",
          redirectPath: "/login"
        });
        setApplied(true);
        setShowNewLoginModal(true);
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}job_wishlist/createjobwishlist`,
        updateWishlist
      );
      setSaved(true);
    } catch (error) {
      console.error(error);
    }
  };

  const check = async (jobId) => {
    if (!userid) {
      setModalConfig({
        message: "Please log in to apply for this job",
        redirectPath: "/login"
      });
      setShowNewLoginModal(true);
      return;
    }
  
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}candidate_details/byuserid/${userid}`);
      if (res.data.data.length === 0) {
        setShowProfileModal(true);
      } else {
        addApplication(jobId);
      }
    } catch (error) {
      addApplication(jobId);
    }
  };


  const checkforsavedjob = async (jobId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}job_wishlist/savedjobs/${userid}`
      );
      const issaved = response.data.some((job) => job.job_id === jobId);
      if (issaved) {
        setSaved(true);
      };
    } catch (e) {
      console.log(e);
    }
  }

  const checkappliedornot = async (jobId, userid) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}job_application/byuserid/${userid}`);
      const data = response.data;
      const appliedjobids = data.map((item) => item.job_id);
      if (appliedjobids.includes(jobId)) {
        setApplied(true);
      } else {
        setApplied(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const fetchAllDetails = async () => {
      try {
        setLoading(true);

        const jobDetailsUrl = `${process.env.REACT_APP_API_URL}job_details/detaileddescription/${jobId}`;
        const jobDetailsResponse = await axios.get(jobDetailsUrl);
        setJobDetails(jobDetailsResponse.data);

        setLoading(false);
      } catch (e) {
        setError(e.message);
        setLoading(false);
      }
    };

    fetchAllDetails();
    if (userid) {
      checkappliedornot(jobId, userid);
      checkforsavedjob(jobId);
    }
  }, [jobId, userid]);


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-3" role="alert">
        Oops! Something went wrong. Please try again later.
      </div>
    )
  }

  if (!jobDetails) {
    return <div className="alert alert-warning">No job details available</div>;
  }


  return (
    <>


      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Job Details</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Job Details</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-1" src="/assets/img/shape/03.svg" alt=""/>
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="/assets/img/shape/05.svg" alt=""/>
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="/assets/img/shape/06.svg" alt=""/>
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="/assets/img/shape/07.svg" alt=""/>
        </div>
      </div> */}
      <Breadcrumb
        title="Job Details"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Job Details", active: true }
        ]}
      />
      
      <div className="job-details py-120 bg-light">
        <div className="container">
          <div className="row ">
            <div className="col-lg-4 px-4">
              <div className="job-details-sidebar bg-white p-5 rounded-2">
                <div className="company-details mb-5">
                  <div className="heading d-flex flex-row gap-3 mb-10">
                    <Link to="/companies">
                    <img
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"
                      src={jobDetails.company_logo ? `${process.env.REACT_APP_API_URL}${jobDetails.company_logo}` : sample_company}
                      className="rounded-4" style={{width: '60px', height: '60px'}} alt=""
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = sample_company;
                      }} />
                    </Link>
                    <div>
                      <h4>{jobDetails.company_name}</h4>
                      <a
                        href={jobDetails.company_website.startsWith('http') ? jobDetails.company_website : `https://${jobDetails.company_website}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'blue' }}
                      >
                        {jobDetails.company_website}
                      </a>
                    </div>
                  </div>
                  <p>{jobDetails.tagline}</p>

                  <hr/>

                  <div className="company-contact mt-3 pt-2">
                    <ul className="d-flex flex-column gap-2">
                      <li className="d-flex gap-2">
                        <i className="far fa-location-dot"></i>
                        <p>{jobDetails.address}, {jobDetails.city_name}, {jobDetails.state_name}, {jobDetails.country_name}, {jobDetails.post_code}</p>
                      </li> 
                      <li className="d-flex gap-2">
                        <i className="far fa-envelope"></i>
                        <a href={`mailto:${jobDetails.email}`}>{jobDetails.email}</a>
                      </li>
                      <li className="d-flex gap-2">
                        <i className="far fa-phone"></i>
                        <a href={`tel:${jobDetails.contact_number}`}>{jobDetails.contact_number}</a>
                      </li>
                      {jobDetails.working_hours && <li className="d-flex gap-2">
                        <i className="far fa-alarm-clock"></i>
                        <p>{jobDetails.working_hours}</p>
                      </li>}
                      {jobDetails.working_days && <li className="d-flex gap-2">
                        <i className="fas fa-calendar-alt me-2"></i>
                        <p>{jobDetails.working_days}</p>
                      </li>}
                    </ul>
                  </div>

                  <div className="buttons mt-5">
                    {userType?.toLowerCase() !== "employer" && (
                      jobDetails.job_external_url ? (
                        applied && userid ? (
                          <button className="theme-btn w-100 border-success" disabled>
                            <i className="fas fa-check-circle me-2"></i>
                            Applied
                          </button>
                        ) : (
                          <a
                            href={jobDetails.job_external_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="theme-btn w-100"
                            onClick={async (e) => {
                              if (!userid) {
                                e.preventDefault();
                                setModalConfig({ message: "Please log in to apply for this job" });
                                setApplied(true);
                                setShowNewLoginModal(true);
                                return;
                              }
                              if (!applied) {
                                e.preventDefault();
                                await addApplication(jobId);
                                setApplied(true);
                                window.open(jobDetails.job_external_url, "_blank");
                              }
                            }}
                          >
                            Apply Now
                          </a>
                        )
                      ) : (
                        <button
                          className={`theme-btn w-100 ${applied && userid ? 'border-success' : ''}`}
                          onClick={() => check(jobId)}
                          disabled={applied && userid}
                        >
                          {applied && userid ? (
                            <>
                              <i className="fas fa-check-circle me-2"></i>
                              Applied
                            </>
                          ) : (
                            <>
                              <span className="fa-solid fe-briefcase me-2" />
                              Apply Now
                            </>
                          )}
                        </button>
                      )
                    )}

                    <button
                      className={`theme-btn theme-btn2 mt-3 w-100 ${saved && userid ? 'border-success' : ''}`}
                      onClick={() => AddToWishlist(jobId)}
                      disabled={saved && userid}
                    >
                      {saved && userid ? (
                        <>
                          <i className='fas fa-check-circle me-2'></i>
                          Saved
                        </>
                      ) : (
                        <>
                          <span className="fa-solid fe-bookmark me-2" />
                          Save Job
                        </>
                      )}
                    </button>
                  </div>
                </div>
                <hr/>


                <div className="job-overview pt-3">
                  <h5 className="mb-3">Job Overview</h5>
                  <ul className="mt-4">


                    {/* <li className="d-flex gap-3 mb-3 align-items-center">
                      <div className="icon" style={{lineHeight: '38px', color: '#3C65F5', fontSize: '25px'}}>
                        <i className="fal fa-eye"></i>
                      </div>
                      <div className="info">
                        <h6 className="mb-1">Job Views</h6>
                        <p>11,111 Views</p>
                      </div>
                    </li> */}

                    <li className="d-flex gap-3 mb-3 align-items-center">
                      <div className="icon" style={{lineHeight: '38px', color: '#3C65F5', fontSize: '25px'}}>
                        <i className="fal fa-user-friends"></i>
                      </div>
                      <div className="info">
                        <h6 className="mb-1">Number of openings</h6>
                        <p>{jobDetails.number_of_positions}  </p>
                      </div>
                    </li>

                    <li className="d-flex gap-3 mb-3 align-items-center">
                      <div className="icon" style={{lineHeight: '38px', color: '#3C65F5', fontSize: '25px'}}>
                        <i className="fal fa-business-time"></i>
                      </div>
                      <div className="info">
                        <h6 className="mb-1">Job Type</h6>
                        <p>{jobDetails.job_type}</p>
                      </div>
                    </li>

                    <li className="d-flex gap-4 mb-3 align-items-center">
                      <div className="icon" style={{lineHeight: '38px', color: '#3C65F5', fontSize: '25px'}}>
                        <i className="fal fa-location-dot"></i>
                      </div>
                      <div className="info">
                        <h6 className="mb-1">Location</h6>
                        <p>{jobDetails.city_name}, {jobDetails.state_name}, {jobDetails.country_name}, {jobDetails.post_code}</p>
                      </div>
                    </li>

                    <li className="d-flex gap-3 mb-3 align-items-center">
                      <div className="icon" style={{lineHeight: '38px', color: '#3C65F5', fontSize: '25px'}}>
                        <div dangerouslySetInnerHTML={{__html: jobDetails.category_icon}}></div>
                        <i class="fal fa-clock"></i>
                      </div>
                      <div className="info">
                        <h6 className="mb-1">Work mode</h6>
                        <p>{({ wfh: 'Work From Home', hybrid: 'Hybrid', wfo: 'Work From Office' }[jobDetails.work_mode?.toLowerCase()] || jobDetails.work_mode || '-')}</p>
                      </div>
                    </li>


                    <li className="d-flex gap-3 mb-3 align-items-center">
                      <div className="icon" style={{lineHeight: '38px', color: '#3C65F5', fontSize: '25px'}}>
                        <i class="fal fa-industry"></i>
                      </div>
                      <div className="info">
                        <h6 className="mb-1">Industry</h6>
                        <p>{jobDetails.primary_industry}</p>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="job-details-container">
                <div className="job-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h1 className="job-title-detail">{jobDetails.job_name}</h1>
                    <span className={`status-badge ${jobDetails.job_status ? 'active' : 'inactive'}`}>
                      {jobDetails.job_status ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <div className="company-info">
                    <h3>{jobDetails.company_name}</h3>
                    <p>Posted on: {formatDate(jobDetails.post_date)}</p>
                  </div>
                </div>

                <div className="row job-quick-info">
                  <div className="col-md-6">
                    <div className="info-card">
                      <div className="info-item">
                        <i className="far fa-building"></i>
                        <span>Department: {jobDetails.department}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-location-dot"></i>
                        <span>Location: {`${jobDetails.city}, ${jobDetails.state_name}, ${jobDetails.country_name}, ${jobDetails.post_code}` || "Not Available"}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-briefcase"></i>
                        <span>Job Type: {jobDetails.job_type}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-money-bill"></i>
                        <span>Package: {jobDetails.package}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-card">
                      <div className="info-item">
                        <i className="far fa-graduation-cap"></i>
                        <span>Qualification: {jobDetails.qualification}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-clock"></i>
                        <span>Experience: {jobDetails.experience}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-users"></i>
                        <span>Positions: {jobDetails.number_of_positions}</span>
                      </div>
                      { jobDetails.hr_name &&
                        <div className="info-item">
                        <i className="far fa-user-tie"></i>
                        <span>HR: {jobDetails.hr_name || 'Not specified'}</span>
                      </div>
                      }
                      <div className="info-item">
                        <i className="far fa-envelope"></i>
                        <span>Email: {jobDetails.email || 'Not specified'}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section">
                  <h2 className="section-title">Role Overview </h2>
                  <p>{renderContent(jobDetails.role, true)}</p>
                </div>

                

                <div className="section">
                  <h2 className="section-title">Job Description</h2>
                  <p className="description">{renderContent(jobDetails.job_description, true)}</p>
                </div>
                {
                  jobDetails.job_highlights&& <div className="section">
                  <h2 className="section-title">Job Highlights</h2>
                  <p>{renderContent(jobDetails.job_highlights, true)}</p>
                </div>
                }
                <div className="section">
                  <h2 className="section-title">Required Skills</h2>
                  <div className="skills-container cursor-pointer">
                    {jobDetails.skills ? (() => {
                      let skillsArray = [];

                      if (typeof jobDetails.skills === "string") {
                        try {
                          const parsed = JSON.parse(jobDetails.skills);
                          skillsArray = Array.isArray(parsed) ? parsed : [];
                        } catch (err) {
                          return <p>Invalid skill data</p>;
                        }
                      } else if (Array.isArray(jobDetails.skills)) {
                        skillsArray = jobDetails.skills;
                      }

                      return skillsArray.length > 0 ? (
                        skillsArray.map((skill) => (
                          <span key={skill.skill_id} className="skill-badge">
                            {skill.skill_name}
                          </span>
                        ))
                      ) : (
                        <p>No skills specified</p>
                      );
                    })() : (
                      <p>No skills specified</p>
                    )}
                  </div>

                </div>

                {/* {jobDetails.job_external_url && (
                  <div className="section">
                    <h2 className="section-title">External Application</h2>
                    <a href={jobDetails.job_external_url} className="btn btn-primary-detail" target="_blank"
                       rel="noopener noreferrer">
                      Apply Externally
                    </a>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoginModal
        show={showModal}
        onClose={() => setShowModal(false)}
        message={modalConfig.message}
        redirectPath={modalConfig.redirectPath}
      />
        <NewLoginModal
     show={showNewLoginModal}
     onClose={() => setShowNewLoginModal(false)}
     message={modalConfig.message}
     redirectPath={modalConfig.redirectPath}
     />
      <Successwithfeedbackmodal
        show={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        message="Your job application has been submitted successfully!"
      />
      <FailureModal
        show={showFailureModal}
        onClose={() => setShowFailureModal(false)}
        message="Your job application failed to submit!"
      />
      <ProfileModal
        show={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        message={modalConfig.message}
        redirectPath={modalConfig.redirectPath}

      />
    </>
  );
};

export default JobDetails;
